// import { styles, vh, vw } from '@/common/style';
import React, { useEffect, useRef } from 'react';
import { Image, View } from 'react-native';
import RootSibling from 'react-native-root-siblings';
import { styles, vh, vw } from '../../utils/style';
export function Loading(props) {
    const { fullScreen = true, fixed, zIndex = 1000 } = props || {};
    const loadingImg = (React.createElement(Image, { style: styles({
            width: 50,
            height: 50,
        }), source: {
            uri: 'https://cdn-static.kwai.net/kos/s101/nlav11312/shop/c_krn/img/loading-normal.gif',
        } }));
    return fullScreen ? (React.createElement(View, { style: [
            styles({
                zIndex,
                justifyContent: 'center',
                alignItems: 'center',
                transform: [
                    { translateX: (vw(100) - 50) / 2 },
                    { translateY: (vh(100) - 50) / 2 },
                ],
            }),
            {
                position: fixed ? 'fixed' : 'absolute',
            },
        ] }, loadingImg)) : (loadingImg);
}
export function useLoadingDeps(deps) {
    const sliblingRef = useRef(null);
    function show() {
        sliblingRef.current = new RootSibling(React.createElement(Loading, { fullScreen: true, fixed: true }));
    }
    function hide() {
        var _a;
        (_a = sliblingRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    useEffect(() => {
        var _a;
        const show = deps.some((dep) => !!dep);
        if (show) {
            sliblingRef.current = new RootSibling(React.createElement(Loading, { fullScreen: true, fixed: true }));
        }
        else {
            (_a = sliblingRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        }
        return () => {
            var _a;
            (_a = sliblingRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        };
    }, [...deps]);
    return {
        show,
        hide,
    };
}
export default Loading;
